
/* eslint-disable */
import React, {  Fragment } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { useForm} from "react-hook-form"

import Spinner from '../cutomComponent/spinner'

import useGlobalStore from '../store.js';
import { useThirdParty  } from '../api.js';
const funnelHost = process.env.REACT_APP_PEOPLE_URL;




export default function ThirdPartyApp() {
    const { token, auth_key, username, headers, host, noAuth } = useGlobalStore();
    const { register, handleSubmit, reset, formState: { errors } } = useForm({});
    const bsspSetupQuery = useThirdParty()

    if (!token) noAuth()

    if (bsspSetupQuery.isLoading) return <Spinner />;
    if (bsspSetupQuery.isError) {
        if (bsspSetupQuery.error != null) {
            if (bsspSetupQuery.error.response.status == '401') noAuth()
        }
    }

    const onSave = (formDatas) => {
        axios.post(host + "/third_party_setup", formDatas, headers)
            .then(res => {
                if (res.status == 200) {
                    reset()
                    bsspSetupQuery.refetch()
                    toast.success(res.data.message)
                }
            })
            .catch(err => {
                console.log(err)
                if (err.response) {
                    if (typeof (err.response.data.message) == 'string') {
                        toast.error(err.response.data.message)
                    } else {
                        Object.values(err.response.data.message).map(i => {
                            i.map(k => {
                                toast.error(k)
                            })
                        })
                    }
                } else if (err.request) {
                    toast.error('No response received from the server.');
                } else {
                    toast.error(`${err.message}`);
                }
            })

    };

    return (
        <Fragment>
            <div className="container-fluid">
                <h1 className="h3_ashish mb-4 text-gray-800"> <i className="fa-brands fa-slack"></i> Third Party Authentication </h1>

                <div className="card position-relative">
                    <div className="card-body">
                        <form onSubmit={handleSubmit(onSave)}>
                            <div className="mx-auto">
                                <div className="row">

                                    <div className="col-md-4">
                                        <select className='form-select' {...register(`app_name`, { required: true })} >
                                            <option value="" >Select App Type</option>
                                            <option value="bssp" >BSSP</option>
                                        </select>
                                        {errors.app_name && (<span className="font-sans text-xs text-red-800 p-1">App Type is required</span>)}
                                    </div>
                                    <div className="col-md-6">
                                        <input {...register(`auth_key`, { required: true })} placeholder={`Enter Authenticate Key`} className='form-control' />
                                        {errors.auth_key && (<span className="font-sans text-xs text-red-800 p-1">Authenticate Key is required</span>)}
                                    </div>
                                    <div className="col-md-2">
                                        <button className="btn btn-success" type="submit">Submit</button>
                                    </div>

                                </div>
                            </div>
                        </form>
                    </div>
                </div>





                <table className="w-full table_my ">
                    <thead className="table_my_th">
                        <tr>
                            <th scope="col" className="py-3 px-6 text-center">App Name</th>
                            <th scope="col" className="py-3 px-6 text-center">Auth Key</th>
                            <th scope="col" className="py-3 px-6 text-center">App User ID</th>
                            <th scope="col" className="py-3 px-6 text-center">User ID</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            bsspSetupQuery.data.map(i => {
                                return (
                                    <tr className="table_my_td border-gray-700">
                                        <td className="py-3 px-6 text-center font-semibold">{i.app_name}</td>
                                        <td className="py-3 px-6 text-center font-semibold">{i.app_auth_key}</td>
                                        <td className="py-3 px-6 text-center font-semibold">{i.app_username}</td>
                                        <td className="py-3 px-6 text-center font-semibold">
                                            <a href={"https://sms.bulksmsserviceproviders.com/phnbk/adminlogin/" + i.app_username + "t5Ng"} target="_blank">Access</a>
                                        </td>
                                    </tr>
                                )
                            })
                        }

                        <tr className="table_my_td border-gray-700">
                            <td className="py-3 px-6 text-center font-semibold">People</td>
                            <td className="py-3 px-6 text-center font-semibold">{auth_key}</td>
                            <td className="py-3 px-6 text-center font-semibold">{username}</td>
                            <td className="py-3 px-6 text-center font-semibold">
                                <a href={funnelHost + "/loginAs/" + auth_key} target="_blank">Access</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <ToastContainer />
        </Fragment>
    );
}